import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AuthInterceptor } from '@app/_interceptors/auth.interceptor';
import { AuthGuard } from '@app/_guards/auth.guard';
import { SharedModule } from '@app/shared/shared.module';
import { CoreModule } from '@app/core/core.module';

import {
    MatSnackBarModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatSelectModule,
    MatOptionModule,
    MatTableModule,
    MatListModule,
    MatProgressSpinnerModule,
    MatCheckboxModule,
    MatRadioModule,
    MatDatepickerModule,
    MatNativeDateModule
} from '@angular/material';
import { ReportsComponent } from './components/reports/reports.component';

const reportsRoutes: Routes = [{ path: '', component: ReportsComponent, canActivate: [AuthGuard] }];

@NgModule({
    imports: [
        HttpClientModule,
        ReactiveFormsModule,
        FormsModule,
        CoreModule,
        CommonModule,
        SharedModule,
        RouterModule.forChild(reportsRoutes),
        // material
        MatSnackBarModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatIconModule,
        MatSelectModule,
        MatOptionModule,
        MatTableModule,
        MatCheckboxModule,
        MatListModule,
        MatProgressSpinnerModule,
        MatRadioModule,
        MatDatepickerModule,
        MatNativeDateModule
    ],
    declarations: [ReportsComponent],
    exports: [],
    entryComponents: [],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true
        },
        DatePipe
    ]
})
export class ReportsModule {}
